(() => {
  const init = () => {
  if (window.bwProductUXReady) return;
  const emit = (name, attempt = 0) => {
    if (typeof window.clarity === 'function') window.clarity('event', name);
    else if (attempt < 10) setTimeout(() => emit(name, attempt + 1), 1000);
  };
  const main = document.querySelector('product-info[data-section]');
  if (!main) return;
  window.bwProductUXReady = true;
  emit('bw_product_view');
  document.addEventListener('bw:gallery-open', () => emit('bw_gallery_open'));
  document.addEventListener('bw:gallery-next', () => emit('bw_gallery_navigate'));
  main.addEventListener('change', event => {
    if (event.target.closest('variant-selects')) emit('bw_variant_changed');
  });
  const bar = main.querySelector('[data-bw-buy-options]');
  const submit = main.querySelector('product-form [type="submit"]');
  const info = main.querySelector('.product__info-container');
  if (bar && submit && info && 'IntersectionObserver' in window) {
    let inProduct = false;
    let canBuy = false;
    const update = () => { bar.hidden = !inProduct || canBuy; };
    new IntersectionObserver(entries => { inProduct = entries[0].isIntersecting; update(); }).observe(main);
    new IntersectionObserver(entries => { canBuy = entries[0].isIntersecting; update(); }).observe(submit);
    bar.querySelector('a').addEventListener('click', event => {
      event.preventDefault();
      info.scrollIntoView({block:'start',behavior:'instant'});
      const option = info.querySelector('variant-selects select,variant-selects input,product-form [type="submit"]');
      option?.focus({preventScroll:true});
      emit('bw_buy_options_opened');
    });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (event?.source === 'product-form') emit('bw_add_to_cart_success');
    });
    subscribe(PUB_SUB_EVENTS.cartError, () => emit('bw_add_to_cart_error'));
  }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
